/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { USER } from '@/store/types';
import * as api from '@/api/user';
import { AdminPayment } from '@/api/types/user';

export interface StoreUserCodeAdminOrdersState {
  list: AdminPayment[];
  today: number;
  yesterday: number;
  month: number;
}

export default {
  namespaced: true,
  state: {
    list: [],
    today: 0,
    yesterday: 0,
    month: 0,
  },
  getters: {},
  actions: {
    [USER.GET_ORDERS]({ commit }) {
      return new Promise((resolve, reject) => {
        api.getOrders().then((res) => {
          commit(USER.GET_ORDERS, res);
          resolve();
        }).catch(reject);
      });
    },
  },
  mutations: {
    [USER.GET_ORDERS](state, { data, extra: { today, yesterday, month } }) {
      state.list = data;
      state.today = today;
      state.yesterday = yesterday;
      state.month = month;
    },
  },
};
